import { z } from "zod";

/**
 * Source/transport that produced an `InboundEmail` row.
 *
 * Single source of truth: the RPC contract (`@erp/rpc`), the backend Sequelize
 * model, and the frontend `InboundEmailDTO` all derive from this schema, so
 * widening the set is a one-line change here rather than three.
 *
 * - `sendgrid-inbound-webhook` / `microsoft-graph-webhook` — top-level emails
 *   delivered to a monitored mailbox.
 * - `microsoft-graph-item-attachment` / `eml-attachment` — child emails
 *   extracted from an attachment on a forwarded message (an Outlook "forward as
 *   attachment" Graph itemAttachment, or a parsed `.eml` file). See the backend
 *   `attachedEmailIngest.ts`.
 */
export const InboundEmailServiceSchema = z.enum([
  "sendgrid-inbound-webhook",
  "microsoft-graph-webhook",
  "microsoft-graph-item-attachment",
  "eml-attachment",
]);

export type InboundEmailService = z.infer<typeof InboundEmailServiceSchema>;
